export default "__VITE_ASSET__B$Ig5VaZ__"